// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import $http from 'vue-resource';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueSticky from 'vue-sticky';
import vueSmoothScroll from 'vue-smoothscroll';
import VueAnimateNumber from 'vue-animate-number';
import VueI18n from 'vue-i18n';
import Vuebar from 'vuebar';
import App from './App';
import router from './router';
import store from './store';
import labels from './assets/lang/labels';


Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(Meta);
Vue.use($http);
Vue.use(VueAwesomeSwiper);
Vue.use(vueSmoothScroll);
Vue.use(VueAnimateNumber);
Vue.use(VueI18n);
Vue.use(Vuebar);

Vue.directive('sticky', VueSticky);

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages: labels, // set locale messages
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js